/**
 * 唐鑫
 * 路由业务模块类型枚举
 * 路由定义需要在meta中声明所属业务模块
 * 1、如果未声明的路由则会出现在所有模块中（请确认是否有必要这么做，因为它不是BUG，设计即是如此）
 * 2、子路由也需要声明所属模块，必须与主路由所属模块相同，否则会发生未可知的路由加载异常
 */
export enum RouterEnum {
  NONE = 'none',
  /**
   * 工作台
   */
  WORK = 'work',
  /**
   * 社保公积金
   */
  SHEBAO = 'shebao',
  /**
   * 企业管理
   */
  COMPANY = 'company',
  /**
   * 基础人事
   */
  RENSHI = 'renshi',
  /**
   * 电子签
   */
  SIGN = 'sign',
  /**
   * 福利平台
   */
  MALL = 'mall',
  /**
   * 信息采集
   */
  INFORMATION='information',
}
/**
 *
 * 个业务模块AppCode枚举
 *
 */
export enum AppCode {
  /**
   * 社保公积金
   */
  shebao = 'CWS_SHEBAO_HR',

  /**
   * 企业管理
   */
  company = 'CWS_COMPANY_HR',
}
